/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import Cookies from "js-cookie";

// Core
import type ClientApplication from '@client/app';

/*----------------------------------
- TYPES
----------------------------------*/


/*----------------------------------
- SERVICE
----------------------------------*/
export default class ExtensionBridge {

    public constructor( public app: ClientApplication ) {

    }

    public connect() {
        return this.sendMessage('connect', {
            token: Cookies.get('authorization')
        });
    }

    public scrape( scraperId: string, url: string, context?: {} ) {
        return this.sendMessage('scrape', { url, scraperId, context });
    }

    private async sendMessage( type: string, options = {} ) {

        // Check if extension is installed
        const sendCommand = window.sendMsgToCP;
        if (sendCommand === undefined){
            console.error("Failed to send message to extension");
            return false;
        }
        
        return await sendCommand(type, options);
    }
}